import { gql } from "@apollo/client";
import RaceFragment from "../fragments/RaceFragment";

export const GET_RACES_LIST = gql`
  query getRaces(
    $wagerProfile: String
    $filterByTrack: RaceListFilter
    $sortByRaceNumber: RaceListSort
    $product: String
    $brand: String
  ) {
    races: races(
      profile: $wagerProfile
      filter: $filterByTrack
      sort: $sortByRaceNumber
    ) {
      ...Race
    }
  }
  ${RaceFragment.entry}
`;
